import useSWR from 'swr';
import { useEffect } from 'react';
import Router from 'next/router';

const fetcher = async (url) => {
    try {
        const res = await fetch(url);
        if (!res.ok) {
            const text = await res.text();
            throw new Error(`HTTP ${res.status}: ${text}`);
        }
        const json = await res.json();
        return json;
    } catch (error) {
        console.log('Error fetching user data:', error);
        throw error;
    }
}


export default function useUser() {
    const { data: user, mutate: mutateUser, error } = useSWR("/api/accounts/user", fetcher);
    
    if (error) {
        Router.push('/500');
    }

    useEffect(() => {
        if (!user || user?.isLoggedIn == undefined || error) return;

        if (!user?.isLoggedIn) {
            const path = Router.asPath;
            if (path == '/inicia-sesion' || path == '/admin/inicia-sesion') return;
            if (Object.keys(Router.components).length == 2 && path != '/inicia-sesion'){
                localStorage.setItem("previousPath", path);
            }
            Router.push('/inicia-sesion');
        }  

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user]);

    return { user, mutateUser };
}